import React from 'react';
import { Col } from 'react-bootstrap';
import useSuggestion from 'Hooks/useSuggestion';
import Search from 'Components/Common/Search/Search';

export default function TitleSearch(): JSX.Element {
  const {
    artistOptions,
    titleOptions,
    loadingArtist,
    loadingTitle,
    handleLoadMore,
    handleFocusInput,
    handleEnterPrimary,
    handleClickItemPrimary,
  } = useSuggestion({
    fetchList: ['artist', 'title'],
    validQueryObj: {
      validArtist: {
        artistIds: undefined,
        queryArtist: undefined,
        artistId: undefined,
        queryTitle: undefined,
        titleIds: undefined,
      },
    },
  });

  return (
    <>
      <Col md="3" className="px-1 ps-3">
        <Search
          label="アーティスト"
          labelMd="4"
          colMd="8"
          classLabel="px-0 artist-label"
          placeholder="検索"
          showIcon
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryArtist"
          onEnter={() => handleEnterPrimary('queryArtist')}
          onClickResult={handleClickItemPrimary}
          options={artistOptions.options || []}
          loading={loadingArtist}
          onLoadMore={() => handleLoadMore('pageArtist')}
          onFocusInput={() => {
            handleFocusInput('queryArtist', 'pageArtist');
          }}
        />
      </Col>
      <Col md="3" className="px-1 ps-3">
        <Search
          label="タイトル"
          labelMd="4"
          colMd="8"
          classLabel="px-0 title-label"
          placeholder="検索"
          showIcon
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryTitle"
          onEnter={() => handleEnterPrimary('queryTitle')}
          onClickResult={handleClickItemPrimary}
          options={titleOptions.options || []}
          loading={loadingTitle}
          onLoadMore={() => handleLoadMore('pageTitle')}
          onFocusInput={() => {
            handleFocusInput('queryTitle', 'pageTitle');
          }}
        />
      </Col>
    </>
  );
}
